import { render, staticRenderFns } from "./veStuLiteraryActiveMy.vue?vue&type=template&id=55295b7f&scoped=true"
import script from "./veStuLiteraryActiveMy.vue?vue&type=script&lang=js"
export * from "./veStuLiteraryActiveMy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55295b7f",
  null
  
)

export default component.exports